// Score card sparkline (I2 §3.1): 120 × 28px, 1.5px stroke in the band colour,
// a dashed final segment when the latest point includes suggested levels, a
// 3px dot on the latest point. Omitted with fewer than two points.
export function Sparkline({ points, color, max = 100, width = 120, height = 28 }: { points: Array<{ score: number; has_suggested: boolean }>; color: string; max?: number; width?: number; height?: number }) {
  if (points.length < 2) return null
  const n = points.length
  const pad = 3
  const x = (i: number) => pad + ((width - 2 * pad) * i) / (n - 1)
  const y = (s: number) => pad + (height - 2 * pad) * (1 - Math.max(0, Math.min(max, s)) / max)
  const seg = (i: number) => `${x(i).toFixed(1)},${y(points[i].score).toFixed(1)}`
  const solid = points.slice(0, n - 1).map((_, i) => `${i === 0 ? 'M' : 'L'}${seg(i)}`).join(' ')
  const last = points[n - 1]
  const tail = `M${seg(n - 2)} L${seg(n - 1)}`
  const label = `Score ${points[0].score} to ${last.score} across ${n} points`
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} role="img" aria-label={label} data-testid="score-sparkline" className="shrink-0">
      <path d={solid} fill="none" stroke={color} strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" />
      <path d={tail} fill="none" stroke={color} strokeWidth={1.5} strokeLinecap="round" strokeDasharray={last.has_suggested ? '3 3' : undefined} />
      <circle cx={x(n - 1)} cy={y(last.score)} r={3} fill={color} />
    </svg>
  )
}
